import streamingTutorial from './livestreaming-on-obs.mp4';

export const videos = {
  streamingTutorial,
};
